import { render, staticRenderFns } from "./AccountDeletion.vue?vue&type=template&id=63475abf&scoped=true&"
var script = {}
import style0 from "./AccountDeletion.vue?vue&type=style&index=0&id=63475abf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63475abf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
